<template>
  <div class="col-6 p-0" style="height: 200px; border: 0.5px solid #E5E7E8; border-radius: 5px;">
    <div v-show="loading" class="container-loading w-100">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-show="!loading" class="rel-barra col-12"  style="height: 161px">
      <canvas id="graph-seller"></canvas>
    </div>
  </div>
</template>

<script>
import "vue-chartjs";

export default {
  name: "GraphSeller",
  props: ["labels", "payload"],
  data: ()=>{
    return {
      chart: null,
      loading: true
    }
  },
  methods: {
    initChart(){
      var ctx = document.getElementById('graph-seller');

        this.chart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: this.labels,
            datasets: [
              {
                fill: false,
                label: "Score",
                borderColor: "#00E4A0",
                borderWidth: 0.8,
                backgroundColor: "#00E4A0",
                hoverBackgroundColor: "#00E4A0",
                data: this.payload,
              }]
          },
          options: {
            maintainAspectRatio: false,
            animations: {
                tension: {
                  duration: 1000,
                  easing: 'linear',
                  from: 1,
                  to: 0,
                  loop: false
                }
              },
            responsive: true,
            interaction: {
              mode: 'index',
              intersect: false,
            },
            stacked: false,
            plugins: {
              title: {
                display: true,
                text: 'Chart.js Line Chart - Multi Axis'
              }
            },
            scales: {
              y: {
                type: 'linear',
                display: true,
                position: 'left',
              },
              y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                  drawOnChartArea: false,
                },
              },
            }
          }
        });
        this.loading = false
    }
  },
  mounted() {
    this.initChart()
  }
}
</script>

<style scoped>

.container-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  animation: preload 5s forwards linear infinite alternate;
}
</style>